module.exports = __webpack_public_path__ + "assets/img/commentOn-emtry.4e727977.png";